import {
  CheckBoxWithHelperText,
  TextFieldWithHelperText
} from './with-helper-text';
import { withValidations } from '../HOC/with-validations';

export const TextFieldWithValidation = withValidations(TextFieldWithHelperText);
export const CheckBoxWithValidation = withValidations(CheckBoxWithHelperText);
